import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import {Observable, from, map, mergeMap} from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return this.getToken().pipe(mergeMap(token => {
            const idToken = token.toString();
            let cloned;
            if (idToken && !request.url.includes('s3')) {
                cloned = request.clone({
                    headers: request.headers.set('Authorization', idToken)
                });
                if (request.url.includes('images')) {
                    cloned = request.clone({
                        headers: request.headers.set('Authorization', idToken).set('Accept', 'image/jpeg')
                    });
                }
                return next.handle(cloned);
            } else {
                return next.handle(request);
            }
        }));
    }

    private getToken(): Observable<any> {
        return from(fetchAuthSession()).pipe(
            map((session) => session.tokens?.idToken)
        );
    }
}
